module.exports = __webpack_public_path__ + "static/media/nader.b29412ec.jpg";